export default "__VITE_ASSET__023a81f2__"